import React, { useState } from 'react';
import { IUserMenuItems } from '@components/UserMenu/UserMenu';
import { useTranslation } from 'react-i18next';
import { Grid2, IconButton, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useLogoutMutation } from '@services/authApi';
import { IMainNavLinkItems } from '../../constants/pages';
import NavBarDrawer from './NavBarDrawer';

interface HamburgerMenuProps {
  pages: IMainNavLinkItems[];
  userMenuItems: IUserMenuItems[];
  userName: string;
  accountName: string;
}

const HamburgerMenu: React.FC<HamburgerMenuProps> = ({
  pages,
  userMenuItems,
  userName,
  accountName,
}) => {
  const activeLocation = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const dispatch = useDispatch();
  const [deleteLogout] = useLogoutMutation();
  const theme = useTheme();
  const isActive = (path: string) => activeLocation.pathname === path;
  const { t } = useTranslation();

  const truncateUsernameHamburgerMenu = () => {
    return userName?.length > 20
      ? `${userName?.substring(0, 20 - 3)}...`
      : userName;
  };

  const tryLogout = () => {
    deleteLogout({})
      .then(() => {
        dispatch({ type: 'LOGOUT' });
      })
      .catch((error) => {
        console.error(`${t('error_in_delete_operation')}\n`, error);
      });
  };

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }
      setDrawerOpen(open);
    };

  return (
    <Grid2 display={{ xs: 'flex', lg: 'none' }}>
      <IconButton
        edge="start"
        color="inherit"
        aria-label="menu"
        onClick={toggleDrawer(true)}
      >
        <MenuIcon
          sx={{ color: theme.palette.secondary.main, fontSize: '1.8rem' }}
        />
      </IconButton>
      <NavBarDrawer
        drawerOpen={drawerOpen}
        toggleDrawer={toggleDrawer(false)}
        truncateUsername={truncateUsernameHamburgerMenu}
        isActive={isActive}
        pages={pages}
        userMenuItems={userMenuItems}
        tryLogout={() => tryLogout()}
        accountName={accountName}
      />
    </Grid2>
  );
};

export default HamburgerMenu;
